import {useState} from "react";
import {useNavigate} from "react-router-dom";
import {common as stringsCommon, forgotPassword as strings} from "strings";

import Button from "components/Button";
import TextInput from "components/TextInput";
import UnauthLayout from "components/UnauthLayout";

import {useForgotPassword} from "liberty-core/api/react-query/user";

import {useAlert} from "lib/alert";

import styles from "./ForgotPasswordPage.module.css";

export default function ForgotPasswordPage() {
  const alert = useAlert();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const {mutateAsync: forgotPassword, isLoading} = useForgotPassword();

  const onSubmit = (e: React.FormEvent) => {
    if (e) {
      e.preventDefault();
    }
    if (!email || isLoading) {
      return;
    }

    forgotPassword(email)
      .then(() => {
        navigate("/reset-password", {replace: true, state: {email}});
      })
      .catch(() => {
        alert({
          title: stringsCommon.whoops,
          message: stringsCommon.somethingWentWrong,
        });
      });
  };

  return (
    <UnauthLayout rightLink={{label: stringsCommon.login, to: "/login"}}>
      <form onSubmit={onSubmit}>
        <h1 className={styles.h1}>{strings.forgotPassword}</h1>
        <div className={styles.instructions}>{strings.instructions}</div>
        <TextInput
          label={stringsCommon.email}
          type="email"
          autoComplete="email"
          value={email}
          onChangeText={setEmail}
          className={styles.email}
          required={true}
        />
        <Button
          disabled={!email}
          className={styles.button}
          onClick={onSubmit}
          type="submit"
          loading={isLoading}
        >
          {stringsCommon.submit}
        </Button>
      </form>
    </UnauthLayout>
  );
}
